// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1AXDj","text-color":"_1JW2Q","icon-color":"_3ErOW","dark":"iJTjY","desktop-hide":"_3h7lg"};